import {
	getGetMerchantProgramParticipationQueryKey,
	getMerchantProgramParticipation,
	PaginatedMerchantProgramParticipation,
	ProgramError,
} from "@getbread/api-client-program-v2";
import { InfiniteData, useInfiniteQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { getRequestConfig } from "merchant-portal-data/request";

export interface UseGetMerchantProgramParticipationParams {
	merchantID: string;
}

export const useGetMerchantProgramParticipation = ({
	merchantID,
}: UseGetMerchantProgramParticipationParams) => {
	return useInfiniteQuery<
		AxiosResponse<PaginatedMerchantProgramParticipation>,
		ProgramError | string | Error,
		InfiniteData<AxiosResponse<PaginatedMerchantProgramParticipation>>,
		ReturnType<typeof getGetMerchantProgramParticipationQueryKey>,
		number
	>({
		queryKey: getGetMerchantProgramParticipationQueryKey({
			"merchantID.eq": merchantID,
		}),
		initialPageParam: 0,
		queryFn: ({ pageParam, signal }) =>
			getMerchantProgramParticipation(
				{
					"merchantID.eq": merchantID,
					"showArchived": true,
					"limit": 200,
					"offset": pageParam,
				},
				getRequestConfig().request,
				signal,
			),
		enabled: !!merchantID,
		getNextPageParam: (lastPage) => {
			const { offset, limit, total } = lastPage?.data?.pagination || {
				offset: 0,
				limit: 10,
				total: Number.MAX_SAFE_INTEGER,
			};
			return offset + limit < total ? offset + limit : undefined;
		},
	});
};
